import { useTranslation } from 'react-i18next';
import useAppMutation from 'hooks/useAppMutation';
import useNotify from 'hooks/useNotify';
import API from 'services/API';
import {
  CreateOrderAdjustmentResponseTO,
  OrderAdjustmentCreationPayload,
} from 'models/OrderAdjustments';

const useCreateOrderAdjustment = ({ orderUid }: { orderUid: string }) => {
  const { notifyError } = useNotify();
  const { t } = useTranslation();

  const { mutate: createOrderAdjustment, isLoading } = useAppMutation(
    ({
      orderAdjustment,
    }: {
      successCallback: (response: CreateOrderAdjustmentResponseTO) => void;
      orderAdjustment: OrderAdjustmentCreationPayload;
    }) =>
      API.post<CreateOrderAdjustmentResponseTO>(
        `/api/internal/orders/${orderUid}/adjustment-items`,
        orderAdjustment,
      ),
    {
      onSuccess: (response, { successCallback }) => {
        successCallback?.(response.data);
      },
      onError: () => {
        notifyError(
          t('componentOrderAdjustment.error.couldNotAddOrderAdjustment'),
        );
      },
    },
  );

  return {
    createOrderAdjustment,
    isLoading,
  };
};

export default useCreateOrderAdjustment;
